// npm link ../shared.web.vue.components/components/AuthSpa
import FiiAuth from '@uptogether/auth-spa-vue-components/fiiAuthStore'

export default ({ isClient, store }) => {
  const opts = {}
  if (isClient) {
    opts.preserveState = true
  }

  // Set up an array of actions that need
  // to execute when the user logs into the
  // application.  (this is here so that it
  // can be app specific)
  // const hydrateActions = ['social/getGroups', 'survey/getInstructions']
  // Preload all the feature flags so that we can use them in the app without having to make a request every time (using the cache will make it faster)
  // This needs to be synchronous to avoid layout shifting
  const hydrateActions = ['dashboard/getFeatureFlags']

  const hydrateActionsAsync = [
    'dashboard/getAddresses',
    'preloadFinancials',
    'surveyQuestions/loadProfileQuestions',
  ]

  console.log('Registering store: FiiAuth')
  store.registerModule('fiiAuth', FiiAuth, opts)
  store.commit('fiiAuth/setHydrateActions', hydrateActions)
  store.commit('fiiAuth/setHydrateActionsAsync', hydrateActionsAsync)
  // store.commit('fiiAuth/setRedirectCookieName', 'preferred-partner')

  // refresh timer interval, set to 90 seconds.
  // if in the method, it'll check to ensure the user
  // is actually logged in, so this is safe to run
  // always
  setInterval(async () => {
    await store.dispatch('fiiAuth/refreshToken', {}, { root: true })
  }, 90000)
}
